(function ($) {
  $(document).ready(function () {
    $(".menu-btn>a").click(function () {
      $("body").addClass("no-scroll");
      $(".mobile-menu").addClass("active");
    });
    $(".menu-close>a").click(function () {
      $("body").removeClass("no-scroll");
      $(".mobile-menu").removeClass("active");
    });

    $(".mobile-menu-link li a").on("click", function () {
      var target = $(this).attr("data-rel");
      $(".mobile-menu-link li a").removeClass("active");
      $(this).addClass("active");
      $("#" + target)
        .fadeIn("slow")
        .siblings(".megamenu")
        .hide();
      return false;
    });

    //.faq-list li a
    $(".faq-list li a").click(function (e) {
      e.preventDefault();

      var href = $(this).attr("href");
      var headerH = $(".header_wrap").innerHeight();
      var headerTH = headerH + 15;
      var scrollTo = $(href).offset().top - headerTH;

      $("html, body").animate(
        {
          scrollTop: scrollTo,
        },
        400
      );
    });

    $(".cart-icon").click(function () {
      document.body.style.setProperty('--scroll-y', `-${window.scrollY}px`);
      $('body').addClass('mobile-no-scroll');
      $(".side-cart").addClass("active", 250);
    });
    $(".hhja").click(function () {
      document.body.style.setProperty('--scroll-y', `-${window.scrollY}px`);
      $('body').addClass('mobile-no-scroll');
      $(".side-cart").addClass("active", 250);
    });
    $(".close-cart").click(function () {
      var scrollY = document.body.style.getPropertyValue('--scroll-y');
      $("body").removeClass("mobile-no-scroll");
      document.documentElement.style.scrollBehavior = 'auto';
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
      document.documentElement.style.scrollBehavior = '';
      $(".side-cart").removeClass("active", 250);
    });

    $(".layer14").on("click", function (e) {
      e.preventDefault(); // prevent hard jump, the default behavior
      var target = $(this).attr("href"); // Set the target as variable
      console.log(target);

      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: $(target).offset().top - 100,
          },
          600,
          function () {
            //location.hash = target; //attach the hash (#jumptarget) to the pageurl
            console.log($(target).offset().top);
          }
        );

      return false;
    });
    $(".down-btn").on("click", function (e) {
      e.preventDefault(); // prevent hard jump, the default behavior
      var target = $(this).attr("href"); // Set the target as variable
      console.log(target);

      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: $(target).offset().top - 50,
          },
          600,
          function () {
            //location.hash = target; //attach the hash (#jumptarget) to the pageurl
            console.log($(target).offset().top);
          }
        );

      return false;
    });
    $(".down-btn2").on("click", function (e) {
      e.preventDefault(); // prevent hard jump, the default behavior
      var target = $(this).attr("href"); // Set the target as variable
      console.log(target);

      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: $(target).offset().top - 340,
          },
          600,
          function () {
            //location.hash = target; //attach the hash (#jumptarget) to the pageurl
            console.log($(target).offset().top);
          }
        );

      return false;
    });

    $(".omni-collection-banner-footer .down-btn2, .omni-sample-collection-banner-footer .down-btn2 ").on("click", function (e) {
      e.preventDefault(); // prevent hard jump, the default behavior
      var target = $(this).attr("href"); // Set the target as variable
      console.log(target);

      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: $(target).offset().top - 120,
          },
          600,
          function () {
            //location.hash = target; //attach the hash (#jumptarget) to the pageurl
            console.log($(target).offset().top);
          }
        );

      return false;
    });

    $(".hero-slider").slick({
      dots: true,
      infinite: true,
      arrows: false,
      //fade:true,
      slidesToShow: 1,
      asNavFor: ".ab-industry-nav",
      slidesToScroll: 1,
    });

    $(".ab-industry-nav").slick({
      dots: false,
      infinite: true,
      arrows: false,
      //fade:true,
      asNavFor: ".hero-slider",
      slidesToShow: 1,
      slidesToScroll: 1,
    });

    $("#slider").layerSlider({
      sliderVersion: "6.0.0",
      type: "fullsize",
      responsiveUnder: 1,
      layersContainer: 1600,
      maxRatio: 1,
      parallaxScrollReverse: true,
      hideUnder: 0,
      hideOver: 100000,
      skin: "v6",
      allowRestartOnResize: true,
      thumbnailNavigation: "disabled",
      skinsPath: "../../layerslider/skins/",
      height: 1048,
    });

    $("#slider2").layerSlider({
      sliderVersion: "6.0.0",
      type: "fullsize",
      responsiveUnder: 1,
      layersContainer: 375,
      maxRatio: 1,
      parallaxScrollReverse: true,
      hideUnder: 0,
      hideOver: 100000,
      skin: "v6",
      allowRestartOnResize: true,
      thumbnailNavigation: "disabled",
      skinsPath: "../../layerslider/skins/",
      height: 741,
    });

    $(".a-what-new-slide").slick({
      dots: true,
      infinite: false,
      arrows: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      prevArrow: $(".prev"),
      nextArrow: $(".next"),
      centerPadding: "370px",
      draggable: false,
      swipe: false,
      touchMove: false,
      responsive: [
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "221px",
            accesibility: false,
            draggable: false,
            swipe: false,
            touchMove: false,
          },
        },
        {
          breakpoint: 1605,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "221px",
            accesibility: false,
            draggable: false,
            swipe: false,
            touchMove: false,
          },
        },
        {
          breakpoint: 1578,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "140px",
            accesibility: false,
            draggable: false,
            swipe: false,
            touchMove: false,
          },
        },
        {
          breakpoint: 1410,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "20px",
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: "20px",
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            centerMode: false,
            centerPadding: "0",
            slidesToScroll: 1,
            accesibility: true,
            draggable: true,
            swipe: true,
            touchMove: true,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            centerMode: false,
            centerPadding: "120px",
            slidesToScroll: 1,
            accesibility: true,
            draggable: true,
            swipe: true,
            touchMove: true,
          },
        },
        // {
        //   breakpoint: 480,
        //   settings: {
        //     slidesToShow: 1,
        //     centerMode: true,
        //     centerPadding: '30px',
        //     slidesToScroll: 1
        //   }
        // },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 2,
            centerMode: false,
            centerPadding: "0",
            slidesToScroll: 2,
            accessibility: true,
            draggable: true,
            swipe: true,
            touchMove: true,
            infinite: true
          }
        }
      ]
    });

    $(".custom-slide").slick({
      dots: false,
      infinite: false,
      arrows: true,
      speed: 300,
      centerMode: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      prevArrow: $(".prevb"),
      nextArrow: $(".nextb"),
      centerPadding: "222px",
      responsive: [
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: "221px",
          },
        },
        {
          breakpoint: 1605,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: "221px",
          },
        },
        {
          breakpoint: 1578,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: "140px",
          },
        },
        {
          breakpoint: 1410,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: "20px",
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            initialSlide: 1,
            centerMode: false,
            centerPadding: "20px",
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            initialSlide: 1,
            centerMode: false,
            arrows: false,
            centerPadding: "40px",
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            initialSlide: 1,
            centerMode: false,
            arrows: false,
            centerPadding: "0px",
            slidesToScroll: 1,
          },
        },
        // {
        //   breakpoint: 480,
        //   settings: {
        //     slidesToShow: 1,
        //     centerMode: true,
        //     centerPadding: '30px',
        //     slidesToScroll: 1
        //   }
        // },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
            initialSlide: 0,
            centerMode: false,
            arrows: false,
            centerPadding: "60px",
            slidesToScroll: 1,
          },
        },
      ],
    });

    $(".quantum-collection-row .custom-slide2").slick({
      dots: false,
      infinite: false,
      arrows: true,
      speed: 300,
      centerMode: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      prevArrow: $(".prevb"),
      nextArrow: $(".nextb"),
      centerPadding: '222px',
      responsive: [
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: '221px',
          },
        },
        {
          breakpoint: 1605,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: "221px",
          },
        },
        {
          breakpoint: 1578,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: "140px",
          },
        },
        {
          breakpoint: 1410,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: "20px",
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            initialSlide: 1,
            centerMode: false,
            centerPadding: "20px",
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            initialSlide: 1,
            centerMode: false,
            arrows: true,
            centerPadding: "40px",
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            initialSlide: 1,
            centerMode: false,
            arrows: true,
            centerPadding: "120px",
            slidesToScroll: 2,
          },
        },
        // {
        //   breakpoint: 480,
        //   settings: {
        //     slidesToShow: 1,
        //     centerMode: false,
        //     centerPadding: '30px',
        //     slidesToScroll: 3
        //   }
        // },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 2,
            infinite: true,
            centerMode: false,
            arrows: true,
            centerPadding: "20px",
            slidesToScroll: 2,
            initialSlide: 0,
          },
        },
      ],
    });

    $(".quantum-collection-row .sample-kit-slider").slick({
      dots: false,
      infinite: false,
      arrows: true,
      speed: 300,
      centerMode: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      prevArrow: $(".prevb"),
      nextArrow: $(".nextb"),
      centerPadding: '222px',
      responsive: [
        {
          breakpoint: 2500,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: '221px',
          },
        },
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: '221px',
          },
        },
        {
          breakpoint: 1605,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: "221px",
          },
        },
        {
          breakpoint: 1578,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: "140px",
          },
        },
        {
          breakpoint: 1410,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: "20px",
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            initialSlide: 1,
            centerMode: false,
            centerPadding: "20px",
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            initialSlide: 1,
            centerMode: false,
            arrows: true,
            centerPadding: "40px",
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            initialSlide: 1,
            centerMode: false,
            arrows: true,
            centerPadding: "120px",
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 2,
            infinite: true,
            centerMode: false,
            arrows: true,
            centerPadding: "20px",
            slidesToScroll: 1,
            initialSlide: 0,
          },
        },
      ],
    });


    $(".quantum-collection-row .custom-slide3").slick({
      dots: false,
      infinite: true,
      arrows: true,
      speed: 300,
      centerMode: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow: $(".prevb"),
      nextArrow: $(".nextb"),
      centerPadding: '222px',
      responsive: [
        {
          breakpoint: 1900,
          settings: {
            //  slidesToShow: 3,
            //  slidesToScroll: 3,
            //  centerMode: true,
            // centerPadding: '221px',
          },
        },
        {
          breakpoint: 1605,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "221px",
          },
        },
        {
          breakpoint: 1578,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "140px",
          },
        },
        {
          breakpoint: 1410,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "20px",
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            centerMode: true,
            centerPadding: "20px",
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            centerMode: true,
            arrows: true,
            centerPadding: "40px",
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            centerMode: true,
            arrows: false,
            centerPadding: "120px",
            slidesToScroll: 1,
          },
        },
        // {
        //   breakpoint: 480,
        //   settings: {
        //     slidesToShow: 1,
        //     centerMode: true,
        //     centerPadding: '30px',
        //     slidesToScroll: 1
        //   }
        // },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            arrows: true,
            centerPadding: "125px",
            slidesToScroll: 1,
          },
        },
      ],
    });


    //       $('.custom-arrow .prevb').on('click', function() {
    //     $('.custom-slide3.slick-slider').find('.slick-prev').trigger('click');
    // });


    // $('.custom-arrow .nextb').on('click', function() {
    //     $('.custom-slide3.slick-slider').find('.slick-next').trigger('click');
    // });


    // if ($(window).width() > 768) {
    //   $(".other-pro-head .nextb").trigger("click");
    // }
  });

  $(".footer-link h3").click(function () {
    $(this).toggleClass("active", 500);
    $(this).next(".show-m").toggle(500);
  });

  $(".h-blog-slide")
    .on("init setPosition", function (event, slick) {
      var el = this;
      if (!el.closest(".h-blog-clip")) return;
      var $first = $(el).find(".slick-slide").not(".slick-cloned").first();
      var w = $first.outerWidth();
      var infinite = slick && slick.options && slick.options.infinite;
      if (infinite && w) {
        el.style.setProperty("--h-blog-slide-offset", -w + "px");
        el.style.setProperty("--h-blog-slide-width", w + "px");
      } else {
        el.style.setProperty("--h-blog-slide-offset", "0px");
        el.style.setProperty("--h-blog-slide-width", "0px");
      }
    })
    .slick({
    dots: true,
    appendDots: $(".h-blog.recent-blog-posts .h-head-b"),
    infinite: true,
    arrows: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 4,
    centerMode: true,
    prevArrow: $(".prevb"),
    nextArrow: $(".nextb"),
    centerPadding: "600px",
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1760,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 4,
          centerMode: true,
          centerPadding: "450px",
        },
      },
      {
        breakpoint: 1325,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          centerMode: true,
          centerPadding: "250px",
        },
      },
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          centerMode: true,
          centerPadding: "300px",
        },
      },
      {
        breakpoint: 767,
        settings: {
          appendDots: $(".h-blog.recent-blog-posts .h-blog-slide"),
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          centerMode: true,
          centerPadding: "50px",
        },
      },
      {
        breakpoint: 500,
        settings: {
          appendDots: $(".h-blog.recent-blog-posts .h-blog-slide"),
          slidesToShow: 1,
          centerMode: true,
          infinite: false,
          arrows: false,
          centerPadding: "10px",
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(document).ready(function () {
    $(".h-blog-slides").slick({
      dots: false,
      infinite: true,
      arrows: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 2,
      centerMode: true,
      prevArrow: $(".prevb"),
      nextArrow: $(".nextb"),
      centerPadding: "300px",
      responsive: [
        {
          breakpoint: 1602,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 2,
            centerMode: true,
            centerPadding: "215px",
          },
        },
        {
          breakpoint: 1500,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: true,
            centerPadding: "150px",
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            centerMode: true,
            centerPadding: "50px",
          },
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            infinite: false,
            arrows: false,
            centerPadding: "36px",
            slidesToScroll: 1,
          },
        },
      ],
    });

    $(".categories_slide").slick({
      dots: false,
      infinite: false,
      arrows: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      // prevArrow: $('.prev'),
      // nextArrow: $('.next'),
      prevArrow:
        "<button type='button' class='prev '><img src='https://cdn.shopify.com/s/files/1/2149/6413/t/58/assets/prev-arrow.svg?v=76522808690051958051672654040'></button>",
      nextArrow:
        "<button type='button' class='next'><img src='https://cdn.shopify.com/s/files/1/2149/6413/t/58/assets/next-arrow.svg?v=84518816879809468751672654040'></button>",
      centerPadding: "300px",
      responsive: [
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "221px",
          },
        },
        {
          breakpoint: 1605,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "221px",
          },
        },
        {
          breakpoint: 1578,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "140px",
          },
        },
        {
          breakpoint: 1410,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "80px",
          },
        },
        {
          breakpoint: 1240,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: "40px",
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            arrows: false,
            centerPadding: "40px",
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            arrows: false,
            centerPadding: "120px",
            slidesToScroll: 1,
          },
        },
        // {
        //   breakpoint: 480,
        //   settings: {
        //     slidesToShow: 1,
        //     centerMode: true,
        //     centerPadding: '30px',
        //     slidesToScroll: 1
        //   }
        // },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
            arrows: false,
            centerMode: true,
            centerPadding: "120px",
            slidesToScroll: 1,
          },
        },
      ],
    });
  });

  $(".single-blog .img a").each(function () {
    $(this).find("img:first").hide();
    var _Bg = "url(" + $(this).find("img:first").attr("src") + ")";
    $(this).css("background-image", _Bg);
    $(this).find("img:first").hide();
  });

  $(".single-case-studies .img a").each(function () {
    $(this).find("img:first").hide();
    var _Bg = "url(" + $(this).find("img:first").attr("src") + ")";
    $(this).css("background-image", _Bg);
    $(this).find("img:first").hide();
  });
  $(".single-media .img").each(function () {
    $(this).find("img:first").hide();
    var _Bg = "url(" + $(this).find("img:first").attr("src") + ")";
    $(this).css("background-image", _Bg);
    $(this).find("img:first").hide();
  });

  $(".article-template-banner").each(function () {
    $(this).find("img:first").hide();
    var _Bg = "url(" + $(this).find("img:first").attr("src") + ")";
    $(this).css("background-image", _Bg);
    $(this).find("img:first").hide();
  });

  jQuery(".video")
    .parent()
    .click(function () {
      if ($(this).children(".video").get(0).paused) {
        $(this).children(".video").get(0).play();
        $(this).children(".playpause").fadeOut();
      } else {
        $(this).children(".video").get(0).pause();
        $(this).children(".playpause").fadeIn();
      }
    });

  $(document).on('click', '.qty-flex .qty', function (t) {
    var $button = $(this);
    if ($button.closest('.side-cart').length) return;
    var oldValue = $button.parent().find("input").val();

    if ($button.hasClass("qty-plus")) {
      var newVal = parseFloat(oldValue) + 1;
    } else {
      // Don't allow decrementing below zero
      if (oldValue > 0) {
        var newVal = parseFloat(oldValue) - 1;
      } else {
        newVal = 0;
      }
    }

    $button.parent().parent().find("input").val(newVal);
  });

  const createSVG = (width, height, radius) => {
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");

    const rectangle = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "rect"
    );

    svg.setAttributeNS(
      "http://www.w3.org/2000/svg",
      "viewBox",
      `0 0 ${width} ${height}`
    );

    rectangle.setAttribute("x", "0");
    rectangle.setAttribute("y", "0");
    rectangle.setAttribute("width", "100%");
    rectangle.setAttribute("height", "100%");
    rectangle.setAttribute("rx", `${radius}`);
    rectangle.setAttribute("ry", `${radius}`);
    rectangle.setAttribute("pathLength", "10");

    svg.appendChild(rectangle);

    return svg;
  };

  document.querySelectorAll(".btn-primary").forEach((button) => {
    const style = getComputedStyle(button);

    const lines = document.createElement("div");

    lines.classList.add("lines");

    const groupTop = document.createElement("div");
    const groupBottom = document.createElement("div");

    const svg = createSVG(
      button.offsetWidth,
      button.offsetHeight,
      parseInt(style.borderRadius, 10)
    );

    groupTop.appendChild(svg);
    groupTop.appendChild(svg.cloneNode(true));
    groupTop.appendChild(svg.cloneNode(true));
    groupTop.appendChild(svg.cloneNode(true));

    groupBottom.appendChild(svg.cloneNode(true));
    groupBottom.appendChild(svg.cloneNode(true));
    groupBottom.appendChild(svg.cloneNode(true));
    groupBottom.appendChild(svg.cloneNode(true));

    lines.appendChild(groupTop);
    lines.appendChild(groupBottom);

    button.appendChild(lines);

    button.addEventListener("pointerenter", () => {
      button.classList.add("start");
    });

    svg.addEventListener("animationend", () => {
      button.classList.remove("start");
    });
  });

  $(".product-slide").slick({
    dots: true,
    infinite: false,
    arrows: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow:
      "<button type='button' class='prev'><img src='https://cdn.shopify.com/s/files/1/2149/6413/t/58/assets/prev-arrow.svg?v=76522808690051958051672654040'></button>",
    nextArrow:
      "<button type='button' class='next'><img src='https://cdn.shopify.com/s/files/1/2149/6413/t/58/assets/next-arrow.svg?v=84518816879809468751672654040'></button>",
  });

  $(document).ready(function () {
    $('ul.accordion').accordion();
  });
  $(window).load(function () {
    console.log('Specs items:', $(".pro-specifications .accordion li a").length);
    console.log('FAQ items:', $(".collection-faq-wrap .accordion li a").length);
    $(".collection-faq-wrap .accordion li a").eq(0).trigger("click");
    $(".pro-specifications .accordion li a").eq(0).trigger("click");
    $(".sample-aaplication-faq .accordion li a").eq(0).trigger("click");
    // $(".pro-faq-qua-wrap .collection-faq-row .accordion li a")
    //   .eq(0)
    //   .trigger("click");
    $(".pro-faq-wrap .collection-faq-row .accordion li a")
      .eq(0)
      .trigger("click");
  });

  $(document).on("scroll", function () {
    var featHeight = $(".ab-product-wrap").height();
    setTimeout(function () {
      if ($(document).scrollTop() > featHeight) {
        $(".sticky_cart").addClass("fixed");
      } else {
        $(".sticky_cart").removeClass("fixed");
      }
    }, 300);
  });

  $(document).ready(function () {
    $(".product2-des .select-dropdown__button").click(function () {
      $(this).parents(".swatch").toggleClass("active");
      $(this).parents("body").toggleClass("activew");
      $(this).parents(".swatch").siblings().removeClass("active");
    });

    $(".blal").click(function () {
      var valu = $(this).attr("data-value");
      $(this)
        .parent(".select-dropdown__list-item")
        .parent(".select-dropdown__list")
        .parent(".select-dropdown")
        .find(".spentxt")
        .html(valu);
      $(this)
        .parent(".select-dropdown__list-item")
        .parent(".select-dropdown__list")
        .removeClass("active");
      $(this).parents().find(".swatch").removeClass("active");
    });
  });

  //  $(".blal ").click(function() {
  //   $(this).closest('.select-dropdown').find('.select-dropdown__button span').text($(this).text());
  // });
  $(document).ready(function () {
    $(document).keydown(function (e) {
      if (e.keyCode == 27) {
        $(".swatch ").removeClass("active");
        $("body").removeClass("activew");
        $(".Collapsible .collapse-headers").removeClass("active");
        $(".Collapsible").removeClass("active");
      }
    });
  });
  $(document).mouseup(function (e) {
    var container = $(".swatch");
    var containerfilter = $(".Collapsible");
    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $(".swatch").removeClass("active");
      $("body").removeClass("activew");
    }
    if (
      !containerfilter.is(e.target) &&
      containerfilter.has(e.target).length === 0
    ) {
      $(".Collapsible .collapse-headers").removeClass("active");
      $(".Collapsible").removeClass("active");
    }
  });

  $(document).ready(function () {
    const startTime = performance.now();

    // Find all text nodes in the body
    const walk = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );

    const nodesToModify = [];
    let node;

    // Collect all text nodes containing ®
    while (node = walk.nextNode()) {
      if (node.nodeValue.includes('®')) {
        nodesToModify.push(node);
      }
    }

    // Replace ® with <sup>®</sup> in collected nodes
    nodesToModify.forEach(textNode => {
      const fragment = document.createDocumentFragment();
      const parts = textNode.nodeValue.split(/(®)/g);

      parts.forEach(part => {
        if (part === '®') {
          const sup = document.createElement('sup');
          sup.textContent = '®';
          fragment.appendChild(sup);
        } else {
          fragment.appendChild(document.createTextNode(part));
        }
      });

      textNode.parentNode.replaceChild(fragment, textNode);
    });

    const endTime = performance.now();
    console.log(`FOUND AND WRAPPED ${nodesToModify.length} REGISTERED TRADEMARKS IN ${(endTime - startTime).toFixed(2)}ms`);
  });


  $(".toggle").click(function () {
    $(".product2-right").toggleClass("active");
  });

  //     $(document).on('click', '.collapse-headers', function(){
  //   $(this).toggleClass('active');
  //   $(this).next('.collapse-items').toggleClass('show');
  // });

  $("body").on(
    "click",
    ".collection-filters-form .Collapsible .collapse-headers", ".collapse-headers img",
    function () {
      $(this).toggleClass("active");
      $(this).parent(".Collapsible").toggleClass("active");
      // $(this).parents('body').toggleClass("activew");
      $(this).parent(".Collapsible").siblings().removeClass("active");
    }
  );
  //   $('.Collapsible .collapse-headers').click(function(event){
  //    event.stopPropagation();
  // });
  //       $('body').click(function() {
  //    $('.Collapsible .collapse-headers').removeClass("active");
  //         $('.Collapsible').removeClass("active");
  // });

  //   $('input#Search-In-Modal-1').keyup(function() {
  //      if($(this).val().length > 1) {
  //         $('body').addClass("width-100");

  //     } else {
  //        $('body').removeClass("width-100");
  //     }
  // });
  $(".search-icon").click(function () {
    $(".desk-search_wrap").addClass("active"),
      setTimeout(function () {
        
        $("#goal-input").focus();
        $(".Search__Input").focus();
      }, 500);
       
    $('body').addClass('no-scroll');
    }),
      
    $('.search-i').click(function(){
    $('.desk-search_wrap').removeClass('active');
    $('body').removeClass('no-scroll');
      $('.header__search details').removeAttr("open");
      $('input[type="search"]').val('');
      $('.Search__Results').attr('aria-hidden', 'true'); // hide results
    })

 //$('.modal__close-button').click(function(){
   // $('body').removeClass("width-100");
    //$('input.search__input[type="search"]').val('');
    //$(".search-modal__form").removeAttr("open");
  //});

  $(window).scroll(function () {
    var sticky = $(".header_wrap"),
      scroll = $(window).scrollTop();

    if (scroll >= 50) sticky.addClass("fixed");
    else sticky.removeClass("fixed");
  });

  $(".mobile-show-f .link").click(function () {
    $(".faq-list").toggleClass("more", 500);
    if ($(".mobile-show-f .link").text() == "MORE FILTERS") {
      $(this).text("CLOSE FILTERS");
    } else {
      $(this).text("MORE FILTERS");
    }
  });

  $("a.link.read-bio").click(function () {
    $(this).parents(".meet-team-row").addClass("show-bio");
  });
  $(".link.hide-bio ").click(function () {
    $(this).parents(".meet-team-row").removeClass("show-bio");
  });

  $(".add_to_cart_buttona").click(function () {
    $(this).addClass("active");
    setTimeout(function () {
      $(".add_to_cart_buttona").removeClass("active");
    }, 250);
  });
  $(".btn").click(function () {
    $(this).addClass("active");
    setTimeout(function () {
      $(".btn").removeClass("active");
    }, 400);
  });

  // $(document).ready(function(){
  //       $(".accordion-titel").click(function(){
  //       $(this).parent(".accordion-item").find(".accordion-contant").slideToggle();
  //       $(this).parent(".accordion-item").prevAll(".accordion-item").find(".accordion-contant").slideUp();
  //       $(this).parent(".accordion-item").nextAll(".accordion-item").find(".accordion-contant").slideUp();
  //       });
  //   });

  //   $(document).ready(function() {
  // 	$('.accordion-item').on('click', '.accordion-titel', function() {
  // 		$('.accordion-contant').slideUp().removeClass('flipInX');
  // 		$('.accordion-titel').removeClass('fa-minus');
  // 		if($(this).next().is(':hidden')) {
  // 			$(this).next().slideDown().addClass('flipInX');
  // 			$(this).find('.accordion-titel').addClass('fa-minus');
  // 		} else {
  // 			$(this).next().slideUp();
  // 			$(this).find('.accordion-titel').addClass('fa-plus');
  // 		}
  // 	});
  // });

  $(".accordion-item").on("click", ".accordion-titel", function () {
    $(".accordion-contant").slideUp();

    if ($(this).hasClass("active")) {
      $(this).next().slideUp();
      $(this).removeClass("active");
    } else {
      $(this).next().slideDown();
      $(".accordion-titel").removeClass("active");
      $(this).addClass("active");
    }
  });

  // $(document).ready(function() {
  //   $.fancybox.open({
  //   type: "inline",
  //   touch: false
  // });
  //});

  $(".open-pop").magnificPopup({
    type: "inline",
    fixedContentPos: true,
    midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
  });
  $(document).ready(function () {
    $(".f-button").click(function () {
      $.magnificPopup.close();
    });
  });
  //   jQuery('#sign-up').fancybox({
  //     mobile: {
  //            clickSlide: false,
  //             touch: false
  //         },
  // });
  //  $(':button').click(function() {
  //     parent.$.fancybox.close();
  // })
  $(window).on("load", function () {
    var $section = $(".h-blog.recent-blog-posts").first();
    if (!$section.length) return;

    var $hHeadB = $section.find(".h-head-b").first();
    if (!$hHeadB.length) return;

    var $arrow = $section.find(".custom-arrow").first();

    if ($arrow.length) {
      $arrow.appendTo($hHeadB).addClass("active");
    }
  });
})(jQuery);

$(document).ready(function () {
  // Attach a click event handler to the select element within the specific .item
  $(".item .select-wrp select").on("change", function () {
    // Get the selected value from the select element
    var selectedValue = $(this).val();

    // Find the parent .item and then find retail_prices within that specific item
    var retailPrices = $(this).closest(".item").find(".retail_prices");

    // Hide all h5 elements under retail_prices within the specific item
    retailPrices.find("div").hide();

    // Show the specific h5 element based on the selected value within the specific item
    retailPrices.find('div[value="' + selectedValue + '"]').show();
  });
});




document.addEventListener('DOMContentLoaded', function () {
  console.log("STICKY CART LISTENER ACTIVE");
  const announcementBar = document.querySelector('.announcement-bar');
  const stickyCart = document.querySelector('.sticky_cart');

  if (announcementBar && stickyCart) {
    stickyCart.classList.add('has-announcement');
  }
});



document.addEventListener('click', function (e) {
  if (e.target.matches('[data-action="select-value"]')) {
    e.preventDefault();

    // Remove is-selected class from any previously selected items
    document.querySelectorAll('[data-action="select-value"]').forEach(el => {
      el.classList.remove('is-selected');
    });

    // Add is-selected class to clicked element
    e.target.classList.add('is-selected');

    const sortValue = e.target.getAttribute('data-value');
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('sort_by', sortValue);

    // Update URL without reload
    window.history.pushState({}, '', currentUrl.toString());

    // Show loading state
    const productGrid = document.querySelector('.ProductList');
    if (productGrid) {
      productGrid.style.opacity = '0.5';
    }

    // Fetch new content
    fetch(currentUrl.toString())
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Get the new product grid
        const newProductGrid = doc.querySelector('.ProductList');

        if (newProductGrid && productGrid) {
          productGrid.innerHTML = newProductGrid.innerHTML;
          productGrid.style.opacity = '1';
        }
      })
      .catch(error => {
        console.error('Error:', error);
        // Fallback to page reload if fetch fails
        window.location.href = currentUrl.toString();
      });
  }
});



document.addEventListener('DOMContentLoaded', function () {
  let isActive = false;

  function isMobile() {
    return window.innerWidth < 615;
  }

  function getCollapsibles() {
    return document.querySelectorAll('.Collapsible.Collapsible--padded.Collapsible--autoExpand');
  }

  // forceClose: true on AJAX reload (always reset); false on resize (preserve open state)
  function setInitialState(forceClose) {
    const collapsibleElements = getCollapsibles();
    if (isMobile()) {
      if (forceClose || !isActive) {
        isActive = false;
        const btn = document.querySelector('.filter-quick a');
        if (btn) btn.classList.remove('active');
        collapsibleElements.forEach(function (element) {
          element.style.display = 'none';
          element.style.height = '0px';
          element.style.opacity = '0';
          element.style.overflow = 'hidden';
          element.style.visibility = 'hidden';
        });
      }
    } else {
      isActive = false;
      collapsibleElements.forEach(function (element) {
        element.style.display = '';
        element.style.height = '';
        element.style.opacity = '';
        element.style.overflow = '';
        element.style.visibility = '';
      });
    }
  }

  setInitialState(true);

  // Debounced resize: iOS fires resize constantly as the address bar slides in/out
  // during scroll. Debouncing prevents those micro-resizes from closing an open filter.
  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { setInitialState(false); }, 200);
  });

  // Re-run after facets.js replaces filter DOM on AJAX filter apply — always force-close.
  // Also briefly suppress pointer events on flavor-type badges: iOS can dispatch a phantom
  // tap at the coordinates of the filter option that was just tapped, and if a badge lands
  // there during the DOM replacement, it would open its tooltip. 500ms covers the settlement
  // window without interfering with intentional badge interactions.
  document.addEventListener('theme:loading:end', function () {
    setInitialState(true);
    if (isMobile()) {
      var badges = document.querySelectorAll('.tooltips.flavor-type-badge');
      badges.forEach(function (b) { b.style.pointerEvents = 'none'; });
      setTimeout(function () {
        badges.forEach(function (b) { b.style.pointerEvents = ''; });
      }, 500);
    }
  });

  // Delegated click — survives DOM replacement by facets.js
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.filter-quick a');
    if (!btn) return;
    if (!isMobile()) return;

    e.preventDefault();
    e.stopPropagation();
    isActive = !isActive;

    btn.classList.toggle('active');

    const collapsibleElements = getCollapsibles();
    collapsibleElements.forEach(function (element) {
      if (isActive) {
        element.style.display = 'block';
        element.style.visibility = 'visible';
        element.style.transition = 'none';
        element.style.height = '0px';
        element.offsetHeight;

        element.style.transition = 'height 0.3s ease-out, opacity 0.3s ease-out';
        element.style.height = element.scrollHeight + 'px';
        element.style.opacity = '1';

        element.addEventListener('transitionend', function handler() {
          if (isActive) {
            element.style.height = 'auto';
            element.style.overflow = 'visible';
          }
          element.removeEventListener('transitionend', handler);
        }, { once: true });
      } else {
        element.style.overflow = 'hidden';
        element.style.height = element.scrollHeight + 'px';
        element.offsetHeight;

        element.style.transition = 'height 0.3s ease-out, opacity 0.3s ease-out';
        element.style.height = '0px';
        element.style.opacity = '0';

        element.addEventListener('transitionend', function handler() {
          if (!isActive) {
            element.style.display = 'none';
            element.style.visibility = 'hidden';
          }
          element.removeEventListener('transitionend', handler);
        }, { once: true });
      }
    });
  });
});